import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

export function ReportDateDialog() {
    return (
        <RsnDialog.Window placement={'center'}>
            <RsnDialog.CenteredHeader>Report date</RsnDialog.CenteredHeader>
            <RsnDialog.Body>
                Reports are generated for completed days only.
                <br />
                To get the latest available report, select yesterday&#39;s date.
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike intent={'secondary'} as={RsnDialog.CloseTrigger}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
